import { useState } from "react";
import { createCalendarDate } from "../..";

const AddCalendarDate = ({ onBack, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    date: "",
    title: "",
    description: "",
    eventType: "event",
  });

  const { date, title, description, eventType } = form;

  const handleInputChange = (name) => (e) => {
    setForm({ ...form, [name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!date || !title.trim()) {
      alert("Date and title are required");
      return;
    }

    setLoading(true);

    try {
      const result = await createCalendarDate({
        date,
        title: title.trim(),
        description: description.trim(),
        eventType,
      });

      if (result.error) {
        alert(result.error);
      } else if (result.message) {
        alert(result.message);
        setForm({
          date: "",
          title: "",
          description: "",
          eventType: "event",
        });
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      alert("An error occurred while creating the calendar date");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    marginBottom: "20px",
  };

  const headerStyle = {
    backgroundColor: "#f8f9fa",
    color: "#2c3e50",
    borderBottom: "2px solid #e9ecef",
    padding: "16px 20px",
    borderRadius: "12px 12px 0 0",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const backButtonStyle = {
    backgroundColor: "#6c757d",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };

  const formGroupStyle = {
    marginBottom: "20px",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#495057",
    fontSize: "14px",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: "#ffffff",
    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
    boxSizing: "border-box",
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: "100px",
    resize: "vertical",
  };

  const selectStyle = {
    ...inputStyle,
    cursor: "pointer",
  };

  const buttonStyle = {
    backgroundColor: "#007bff",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const loadingButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#6c757d",
    cursor: "not-allowed",
  };

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <i className="fas fa-calendar-plus me-2"></i>
          Add Calendar Date
        </div>
        <button
          style={backButtonStyle}
          onClick={onBack}
          title="Back to Calendar Management"
        >
          <i className="fas fa-arrow-left"></i>
          Back
        </button>
      </div>
      <div style={{ padding: "24px" }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  <i className="fas fa-calendar me-2"></i>
                  Date *
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={handleInputChange("date")}
                  style={inputStyle}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  <i className="fas fa-tag me-2"></i>
                  Event Type
                </label>
                <select
                  className="form-control"
                  value={eventType}
                  onChange={handleInputChange("eventType")}
                  style={selectStyle}
                >
                  <option value="event">Event</option>
                  <option value="festival">Festival</option>
                  <option value="holiday">Holiday</option>
                  <option value="special">Special</option>
                </select>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  <i className="fas fa-heading me-2"></i>
                  Title *
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={handleInputChange("title")}
                  placeholder="Enter event title"
                  style={inputStyle}
                  maxLength="100"
                  required
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  <i className="fas fa-align-left me-2"></i>
                  Description
                </label>
                <textarea
                  className="form-control"
                  value={description}
                  onChange={handleInputChange("description")}
                  placeholder="Enter event description (optional)"
                  style={textareaStyle}
                  maxLength="500"
                />
                <small className="text-muted">
                  {description.length}/500 characters
                </small>
              </div>
            </div>
          </div>

          <div style={{ marginTop: "24px" }}>
            <button
              className="btn"
              disabled={loading}
              type="submit"
              style={loading ? loadingButtonStyle : buttonStyle}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Creating...
                </>
              ) : (
                <>
                  <i className="fas fa-calendar-plus"></i>
                  Add Calendar Date
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCalendarDate;
